import React, { useState } from "react";

const Course = () => {
  const [title, setTitle] = useState("");
  const [subtitles, setSubtitles] = useState([""]);
  const [pdf, setPdf] = useState(null);
  const [image, setImage] = useState(null);

  // ✅ Handle Subtitle Change
  const handleSubtitleChange = (index, value) => {
    const updatedSubtitles = [...subtitles];
    updatedSubtitles[index] = value;
    setSubtitles(updatedSubtitles);
  };

  // ✅ Add New Subtitle
  const addSubtitle = () => {
    setSubtitles([...subtitles, ""]);
  };

  // ✅ Remove Subtitle
  const removeSubtitle = (index) => {
    const updatedSubtitles = subtitles.filter((_, i) => i !== index);
    setSubtitles(updatedSubtitles);
  };

  // ✅ Handle File Uploads (PDF/Image)
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (type === "pdf") {
      setPdf(file);
    } else if (type === "image") {
      setImage(file);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append("title", title);
    formData.append("subtitles", JSON.stringify(subtitles));
    if (pdf) formData.append("pdf", pdf);
    if (image) formData.append("image", image);
  
    try {
      const response = await fetch("https://training.megascale.co.in/backend/save_course.php", {
        method: "POST",
        body: formData,
      });
  
      const result = await response.json();
      if (result.success) {
        alert("Course saved successfully!");
        setTitle("");
        setSubtitles([""]);
        setPdf(null);
        setImage(null);
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Error submitting course:", error);
      alert("Failed to save course.");
    }
  };
  

  return (
    <div className="max-w-3xl mx-auto p-6 pt-28 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold text-blue-600 mb-4">Add Course</h2>
      <form onSubmit={handleSubmit} className="space-y-4">

        {/* ✅ Title Input */}
        <div>
          <label className="block font-semibold text-gray-700">Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
            placeholder="Enter course title"
            required
          />
        </div>

        {/* ✅ Subtitles (Dynamic) */}
        <div>
          <label className="block font-semibold text-gray-700">Subtitles</label>
          {subtitles.map((subtitle, index) => (
            <div key={index} className="flex space-x-2 mb-2">
              <input
                type="text"
                value={subtitle}
                onChange={(e) => handleSubtitleChange(index, e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                placeholder={`Subtitle ${index + 1}`}
                required
              />
              <button
                type="button"
                onClick={() => removeSubtitle(index)}
                className="px-3 py-1 text-white bg-red-500 rounded hover:bg-red-600"
              >
                ✕
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={addSubtitle}
            className="mt-2 text-blue-500 font-semibold hover:underline"
          >
            + Add Another Subtitle
          </button>
        </div>

        {/* ✅ Upload PDF */}
        <div>
          <label className="block font-semibold text-gray-700">Upload PDF</label>
          <input
            type="file"
            accept=".pdf"
            onChange={(e) => handleFileChange(e, "pdf")}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
          {pdf && <p className="text-sm text-gray-600 mt-1">Selected: {pdf.name}</p>}
        </div>

        {/* ✅ Upload Image */}
        <div>
          <label className="block font-semibold text-gray-700">Upload Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "image")}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
          {image && (
            <img
              src={URL.createObjectURL(image)}
              alt="Preview"
              className="mt-2 w-32 h-20 object-cover rounded-md"
            />
          )}
        </div>

        {/* ✅ Submit Button */}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 transition"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default Course;
